(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .component('printSignature', {
      templateUrl: 'views/components/print-signature.html',
      bindings: {
        label: '@',
        name: '<'
      }
    });

}());
